var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"inline-block"}},[_c('Icon',{staticClass:"spin-icon-load",attrs:{"type":"ios-loading","size":"18","color":"#2d8cf0"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }